import { render, staticRenderFns } from "./insurerFileUpload.vue?vue&type=template&id=991bfda2&scoped=true&"
import script from "./insurerFileUpload.vue?vue&type=script&lang=js&"
export * from "./insurerFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./insurerFileUpload.vue?vue&type=style&index=0&id=991bfda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991bfda2",
  null
  
)

export default component.exports